export enum PromptType {
  Positive = 'positive',
  Negative = 'negative',
}

export enum PolygonAIActionType {
  Hover = 'hover',
  Select = 'select',
  Undo = 'undo',
  Reset = 'reset',
  SetDataset = 'set_dataset',
}
